<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import PlatformSelect from '../PlatformSelect.vue'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

async function onUpdated(value: string | undefined) {
  await props.context.node.input(value)
}
</script>

<template>
  <PlatformSelect v-bind="context.attrs" :model-value="context.value" @update:model-value="onUpdated" />
</template>
